module.exports = __webpack_public_path__ + "static/media/nevada-cover.4aa6ab50.jpg";